export class UserInfo {
    public userId!: string;
    public returnsNR!: boolean;
}
